module.exports = __webpack_public_path__ + "img/32.3b7e71d2.png";